import React from "react";
import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Quote } from "lucide-react";
import { BIZ, REVIEW, REPUTATION_NOTE } from "./aboData";
import AboLayout, { INK, TEAL, LIGHT, SLATE } from "./AboLayout";
import LawInquiryForm from "@/components/LawInquiryForm";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function AboContact() {
  return (
    <AboLayout active="contact">
      <section className="py-16 sm:py-20" style={{ background: INK }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#5EEAD4" }}>Contact</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">BGC Office</motion.h1>
        </div>
      </section>

      <section className="py-14" style={{ background: LIGHT }}>
        <div className="max-w-2xl mx-auto px-5 sm:px-8 text-center">
          <motion.p {...fadeUp} className="text-sm mb-6" style={{ color: SLATE }}>{REPUTATION_NOTE}</motion.p>
          <motion.div {...fadeUp} className="bg-white rounded-lg p-7 shadow-sm text-left">
            <Quote size={24} style={{ color: TEAL }} className="mb-3" />
            <p className="text-sm" style={{ color: INK }}>"{REVIEW.quote}"</p>
            <p className="mt-4 text-xs" style={{ color: SLATE }}>— {REVIEW.author}, <a href={REVIEW.sourceUrl} target="_blank" rel="noopener noreferrer" className="underline" style={{ color: TEAL }}>{REVIEW.source}</a>, {REVIEW.date}</p>
          </motion.div>
        </div>
      </section>

      <section className="py-16" style={{ background: "white" }}>
        <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-10">
          <motion.div {...fadeUp}>
            <h2 className="text-2xl font-extrabold mb-6" style={{ color: INK }}>Get in Touch</h2>
            <ul className="space-y-4 text-sm mb-6">
              <li className="flex items-start gap-3"><MapPin size={18} style={{ color: TEAL }} className="mt-0.5 shrink-0" />{BIZ.address}</li>
              <li className="flex items-start gap-3"><Phone size={18} style={{ color: TEAL }} className="mt-0.5 shrink-0" /><a href={`tel:${BIZ.phone}`} data-testid="abo-phone-link" className="hover:underline">{BIZ.phoneDisplay}</a> / {BIZ.mobile} (mobile / WhatsApp)</li>
              <li className="flex items-start gap-3"><Mail size={18} style={{ color: TEAL }} className="mt-0.5 shrink-0" /><a href={`mailto:${BIZ.email}`} data-testid="abo-email-link" className="hover:underline">{BIZ.email}</a></li>
            </ul>
            <div className="rounded-lg overflow-hidden shadow-sm min-h-[220px]">
              <iframe title="Abo & Penaranda Law Firm map" src={BIZ.mapEmbed} className="w-full h-full min-h-[220px]" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </motion.div>
          <motion.div {...fadeUp}>
            <LawInquiryForm
              testidPrefix="abo"
              businessName={BIZ.name}
              accent={TEAL}
              accentText="#FFFFFF"
              areasOfLaw={["Corporate / Business", "Litigation", "Family / Estate", "Tax", "Real Estate", "Immigration", "FinTech / Regulatory", "Other / Not sure"]}
              phone={BIZ.phone}
              phoneDisplay={BIZ.phoneDisplay}
              email={BIZ.email}
              messengerUrl={BIZ.facebook}
            />
          </motion.div>
        </div>
      </section>
    </AboLayout>
  );
}
